import { memo } from 'react';
import { AutoCompleteItem, MatchesType, PartsType } from '../types';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';

const HighlightHits = memo(
  ({ search, item }: { search: string; item: AutoCompleteItem }) => {
    const matches: MatchesType = match(item.value, search, {
      insideWords: true,
    });
    const parts: PartsType = parse(item.value, matches);
    return (
      <div>
        {parts.map((part, index) => (
          <span
            key={`${index}-${part.text}`}
            style={{
              fontWeight: part.highlight ? 700 : 400,
            }}
          >
            {part.text}
          </span>
        ))}
      </div>
    );
  }
);

export default HighlightHits;

